export default {
  'story': {
    DISABLED: 'En cours d’édition',
    PUBLISHED: 'Publié',
    PUBLIC: 'Public',
    PRIVATE: 'Privé',
    INTERVIEW: 'Entretien',
    COVERAGE: 'Reportage',
    OPINION: 'Tribune',
    INVESTIGATION: 'Enquête',
    CHRONIC: 'Chronique',
    DEBATE: 'Débat',
    PORTRAIT: 'Portrait',
    ANALYSIS: 'Analyse',
    REVIEW: 'Critique',
    ESSAY: 'Essai',
    FLASH: 'Brève',
    ECHO: 'Echo',
    NARRATIVE: 'Récit',
    STORY: 'Article',
    VIDEO: 'Vidéo',
    AUDIO: 'Audio',
    VIDEO_AUDIO: 'Vidéo et Audio',
    CREATED_AT_DESC: 'Date de création (inverse)',
    PUBLISHED_AT_DESC: 'Date de publication (inverse)',
  },
  'topic': {
    DISABLED: 'En cours d’édition',
    PUBLISHED: 'Publié',
  },
  'author': {
    DISABLED: 'Désactivé',
    ENABLED: 'En ligne',
  },
  ENABLED: 'Activé',
  DISABLED: 'Brouillon',
  PUBLISHED: 'Publié',
  STORY_TAG: 'Tag',
  CATEGORY: 'Catégorie',
  PROGRAM: 'Émission',
  PODCAST: 'Podcast',
  SECTION_HERO: 'À la une',
  SECTION_STORY_HIGHLIGHT: 'À la une des articles',
  SECTION_LAST_PROGRAMS: 'Les dernières émissions',
  SECTION_LAST_STORIES: 'Les derniers articles',
}
